import React from 'react'

import { Col } from '../../../packages/kiti/components/structure/Grid'
import { useForm } from '../../../packages/kiti/components/form/form/FormHandler'
import { useOpenSelectWidgetTypeModal } from '../../../utils/routes/modals/modalsActions'
import Canvas from '../../../packages/kiti/components/canvas/Canvas'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Panel from '../../../packages/kiti/components/structure/Panel'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Text from '../../../packages/kiti/components/presentation/Text'
import Widget from './Widget'

const WidgetsGrid = ({ screen }) => {
  const { editing } = useForm()
  const addNewWidget = useOpenSelectWidgetTypeModal()

  return (
    <>
      <Canvas disabled={!editing}>
        {(screen.items || []).map((item, index) => (
          <Widget key={item.id} widget={item} index={index} />
        ))}

        {false && editing && (
          <Col width="25%" height={13}>
            <Panel height="100%" onClick={() => addNewWidget({ screenId: screen.id })} justify="center" align="center">
              <Icon name="BsPlusCircle" color="dark2" size={1.2} />
              <Separator weight={2} />
              <Text bold color="dark3" align="center">
                Add Widget
              </Text>
            </Panel>
          </Col>
        )}
      </Canvas>
    </>
  )
}

export default WidgetsGrid
